import { render, staticRenderFns } from "./list.vue?vue&type=template&id=bfc0c836&scoped=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"
import style0 from "./list.vue?vue&type=style&index=0&id=bfc0c836&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc0c836",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfc0c836')) {
      api.createRecord('bfc0c836', component.options)
    } else {
      api.reload('bfc0c836', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=bfc0c836&scoped=true", function () {
      api.rerender('bfc0c836', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/category/list.vue"
export default component.exports